var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-navigation-button-v2"},[_c('button',{on:{"click":_vm.toggle}},[_c('bars-icon'),_vm._v(" "+_vm._s(_vm.$t('general.menu'))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }